import { faWindowMaximize, faWindowRestore } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RefObject } from 'react';

interface MaximizeModalProps {
  modalOverlayRef: RefObject<HTMLDivElement | null>;
}

const MaximizeModal = ({ modalOverlayRef }: MaximizeModalProps) => {
  const onToggle = () => {
    modalOverlayRef.current?.classList.toggle('modal-maximized');
  };

  return (
    <>
      <FontAwesomeIcon className="modal-maximize-icon" icon={faWindowMaximize} onClick={onToggle} size='sm' />
      <FontAwesomeIcon className="modal-restore-icon" icon={faWindowRestore} onClick={onToggle} size='sm' />
    </>
  );
};

export default MaximizeModal;